export default {
    resetCustomer(context){
        context.commit('updateName', '')
    },
    setUpdateCustomer(context, payload){
        context.commit('updateName', payload.name)
        context.commit('updateEmail', payload.email)
        context.commit('updatePhone', payload.phone)
        context.commit('updateCelPhone', payload.celPhone)
    },
}


// WEBPACK FOOTER //
// ./src/shared/modules/CustomerNew/vuex/actions.js